import { SpringParallax } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Grid$1 from '../Grid/Grid.js';
import Button$1 from '../../basics/Button/Button.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import Spinner$1 from '../../basics/Spinner/Spinner.js';
import StyledTeaserContainer from './TeaserContainer.style.js';

const TeaserContainer = ({
  children,
  onLoadMore,
  onReset,
  loadMoreLabel,
  resetLabel,
  noEntriesLabel,
  filtering,
  showFilter,
  entriesCount,
  loading
}) => /*#__PURE__*/React$1.createElement(StyledTeaserContainer, {
  filtering: filtering
}, filtering && /*#__PURE__*/React$1.createElement(Spinner$1, {
  className: "teaserContainer__spinner",
  size: "large"
}), /*#__PURE__*/React$1.createElement(Grid$1, {
  className: "teaserContainer__wrapper"
}, children, typeof entriesCount === 'number' && entriesCount === 0 && showFilter ? /*#__PURE__*/React$1.createElement(SpringParallax, {
  className: "teaserContainer__no-results"
}, /*#__PURE__*/React$1.createElement(Typography$1, null, noEntriesLabel), onReset && /*#__PURE__*/React$1.createElement(Button$1, {
  onClick: onReset
}, resetLabel)) : null), onLoadMore && /*#__PURE__*/React$1.createElement(SpringParallax, {
  className: "teaserContainer__load-more"
}, /*#__PURE__*/React$1.createElement(Button$1, {
  onClick: onLoadMore,
  disabled: loading,
  variant: "secondary"
}, loading ? 'Loading' : loadMoreLabel)));

TeaserContainer.propTypes = {
  children: PropTypes$1.node,
  onLoadMore: PropTypes$1.func,
  loading: PropTypes$1.bool,
  filtering: PropTypes$1.bool,
  showFilter: PropTypes$1.bool,
  entriesCount: PropTypes$1.number,
  loadMoreLabel: PropTypes$1.string,
  resetLabel: PropTypes$1.string,
  noEntriesLabel: PropTypes$1.string,
  onReset: PropTypes$1.func
};
TeaserContainer.defaultProps = {
  children: null,
  onLoadMore: undefined,
  loading: false,
  filtering: false,
  showFilter: false,
  entriesCount: undefined,
  loadMoreLabel: 'Load more',
  noEntriesLabel: 'No Entries found',
  resetLabel: 'Reset filter',
  onReset: undefined
};

export default TeaserContainer;
